import { checkHasProjectFile } from "@prismicio/plugin-kit/fs";
import { buildSrcPath } from "./buildSrcPath.js";
async function checkHasAppRouter(args) {
  const appRouterPath = await buildSrcPath({
    filename: "app",
    helpers: args.helpers
  });
  return await checkHasProjectFile({
    filename: appRouterPath,
    helpers: args.helpers
  });
}
export {
  checkHasAppRouter
};
//# sourceMappingURL=checkHasAppRouter.js.map
